window.addEventListener("load", () => {
    const rowsWithGroupAttribute = document.querySelectorAll("[data-rowgroup]");
    const rows = Array.from(rowsWithGroupAttribute);

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const attributeValue = row.getAttribute("data-rowgroup");

        if (attributeValue) {
            const previousElement = rows[i - 1] ?? null;
            const previousElementAttribute = previousElement?.getAttribute("data-rowgroup");

            const nextElement = rows[i + 1] ?? null;
            const nextElementAttribute = nextElement?.getAttribute("data-rowgroup");

            if (previousElementAttribute === attributeValue) {
                row.classList.add("group-middle");
            } else {
                row.classList.add("group-top");
            }

            if (nextElementAttribute === attributeValue) {
                row.classList.add("group-middle");
            } else {
                row.classList.add("group-bottom");
            }
        }
    }
});
